const notice_management_zh = {
  edit_message_info:'编辑通知消息',
  empty_title:'请输入标题',
  empty_content:'请输入内容'
}

export default notice_management_zh



// WEBPACK FOOTER //
// ./src/common/lang/notice_management/notice_management_zh.js